import { Record } from 'immutable'

export interface IDemographicValue {
  readonly year: number
  readonly value: number
  readonly estimated: boolean
  readonly imported: boolean
}

const DemographicValueRecord = Record({
  estimated: false,
  imported: false,
  value: 0,
  year: 0,
})

export class DemographicValue extends DemographicValueRecord
  implements IDemographicValue {
  public static fromJS(initialState?: Partial<IDemographicValue>) {
    if (!initialState) {
      return new DemographicValue()
    }

    const { ...rest } = initialState

    return new DemographicValue({
      ...rest,
    })
  }

  public readonly year: number
  public readonly value: number
  public readonly estimated: boolean
  public readonly imported: boolean

  constructor(initialState?: Partial<DemographicValue>) {
    initialState ? super(initialState) : super()
  }
}
